import { render, staticRenderFns } from "./DaiLiList.vue?vue&type=template&id=4a5fa99d&"
import script from "./DaiLiList.vue?vue&type=script&lang=js&"
export * from "./DaiLiList.vue?vue&type=script&lang=js&"
import style0 from "./DaiLiList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports